export const TENANT_SETTINGS_KEYS = {
    sso: 'SSO',
    privacy: 'Privacy',
    roster: 'Roster',
    whiteLabeling: 'White Labeling',
    admin: 'Admin',
    subjectsFrameworks: 'Subjects/Frameworks',
    mastery: 'Mastery',
    classSettings: 'Class Settings',
    locatingLearner: 'Initial Skyline Config',
    reports: 'Reports',
    study: 'Study',
    mobileApp: 'Mobile App',
    contentTypes: 'Content Types',
    general: 'General',
    learningJourney: 'Learning Journey',
    lorFacets: 'LOR Facets',
    classConfiguration: 'Class Configuration',
};


export const TENANT_SETTINGS_LABEL_KEYS: any = {
    'SSO': 'sso',
    'Privacy': 'privacy',
    'Roster': 'roster',
    'White Labeling': 'whiteLabeling',
    'Admin': 'admin',
    'Subjects/Frameworks': 'subjectsFrameworks',
    'Mastery': 'mastery',
    'Class Settings': 'classSettings',
    'Initial Skyline Config': 'locatingLearner',
    'Reports': 'reports',
    'Study': 'study',
    'Mobile App': 'mobileApp',
    'Content Types': 'contentTypes',
    'General': 'general',
    'Learning Journey': 'learningJourney',
    'LOR Facets': 'lorFacets',
    'Class Configuration': 'classConfiguration',
};
